import { GiftCouponRedeemStatus } from '@shared/api/giftCoupon/giftCoupon.interface';

export const historyStatusLabel: Record<string, { text: string; className: string }> = {
  [GiftCouponRedeemStatus.Delivered]: {
    text: '발송완료',
    className: 'bg-green-100 text-green-700',
  },
  [GiftCouponRedeemStatus.Expired]: {
    text: '만료',
    className: 'bg-gray-100 text-gray-600',
  },
  [GiftCouponRedeemStatus.Refunded]: {
    text: '환불',
    className: 'bg-red-100 text-red-700',
  },
  [GiftCouponRedeemStatus.Canceled]: {
    text: '취소',
    className: 'bg-gray-100 text-gray-500',
  },
  [GiftCouponRedeemStatus.Requested]: {
    text: '신청됨',
    className: 'bg-yellow-100 text-yellow-700',
  },
  [GiftCouponRedeemStatus.Rejected]: {
    text: '발송불가',
    className: 'bg-orange-100 text-orange-700',
  },
  [GiftCouponRedeemStatus.ReselectRequired]: {
    text: '재선택 안내',
    className: 'bg-amber-100 text-amber-700',
  },
};
